"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _enum = require("./enum");
var companyappApi = _interopRequireWildcard(require("@/api/companyappApi"));
var _validate = require("@/utils/validate");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _default(_ref) {
  var handleSearch = _ref.handleSearch;
  var FILTER_ITEMS = [{
    type: 'select',
    label: '页面类型：',
    prop: 'pageType',
    attrs: {
      placeholder: '请选择',
      clearable: true
    },
    options: _enum.pageTypeEnum,
    events: {
      change: function change(val) {
        return handleSearch({
          pageType: val
        });
      }
    }
  }, {
    type: 'select',
    label: '关联小程序：',
    prop: 'appId',
    attrs: {
      placeholder: '请选择',
      clearable: true
    },
    options: [],
    events: {
      change: function change(val) {
        return handleSearch({
          appId: val
        });
      }
    },
    async: true,
    load: function load(item) {
      var res = companyappApi.companyappAutoListApi();
      item.options = (res || []).map(function (v) {
        return {
          label: v.appName,
          value: v.id
        };
      });
    }
  }, {
    type: 'select',
    label: '状态：',
    prop: 'status',
    attrs: {
      placeholder: '请选择',
      clearable: true
    },
    options: [{
      label: '禁用',
      value: 0
    }, {
      label: '启用',
      value: 1
    }],
    events: {
      change: function change(val) {
        return handleSearch({
          status: val
        });
      }
    }
  }];
  return {
    FILTER_ITEMS: FILTER_ITEMS
  };
}